import { connectedAccountsStore } from '../store/store';
import { ConnectedAccount } from '../store/schema/ConnectedAccount';

export function getSelectedAccount(): ConnectedAccount {
    let store = connectedAccountsStore();

    if (store.selected >= 0) {
        return store.accounts[store.selected];
    }

    return null;
}
